import { gsap } from 'gsap'

const animation = gsap.timeline({repeat:-1});

function init(){
  gsap.set('.quote-fader__list-item', {autoAlpha:1});
  animation.from('.quote-fader__list-item', {opacity:0, stagger:{each:6}});
  animation.to('.quote-fader__list-item', {opacity:0, stagger:{each:6}}, 5.75)
}

init()